import type { ReactNode } from 'react'
import React from 'react'

import * as S from './EditorPanelWrapper.styled'

type Props = {
  children: ReactNode
}

export const EditorPanelWrapper = ({ children }: Props) => {
  return <S.Container>{children}</S.Container>
}
